/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import info from '../Res/Icon/info.png';
import './Info.css';

const InfoPopup = ({ onClick, id, text, infoIcon = true, placement = "right", customClass = "" }) => {
  return (
    <>
      {infoIcon && <div id={id} onClick={onClick} className="info-div">
        <img className="info-icon" src={info} alt="info" />
      </div>}
      <UncontrolledTooltip placement={placement} target={id} delay={{ show: 500, hide: 0 }} className={customClass}>
        {text}
      </UncontrolledTooltip>
    </>
  );
};

export default InfoPopup;
